import React from 'react';

const DonutChart = ({ 
  percentage, 
  size = 120, 
  strokeWidth = 12, 
  className = "",
  showPercentage = true,
  centerText = null,
  centerTextClassName = ""
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  
  // Ensure percentage is between 0 and 100
  const normalizedPercentage = Math.max(0, Math.min(100, percentage));
  
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        className="transform -rotate-90"
      >
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
        />
        
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={normalizedPercentage >= 50 ? "#10b981" : "#ef4444"}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-500 ease-in-out"
        />
      </svg>
      
      {/* Center text */}
      <div className="absolute inset-0 flex items-center justify-center">
        {centerText ? (
          <div className={`text-center ${centerTextClassName}`}>
            {centerText}
          </div>
        ) : showPercentage ? (
          <div className={`text-center font-bold text-black ${centerTextClassName}`}>
            {normalizedPercentage.toFixed(1)}%
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DonutChart;
